import { useState } from "react";

const useLocalStorage = <T>(key: string, initialValue: T) => {
  const localValue = localStorage.getItem(key);
  const [state, setState] = useState(localValue ? JSON.parse(localValue) : initialValue);

  const updateState = (value: T) => {
    setState(value);
    localStorage.setItem(key, JSON.stringify(value));
  };

  return [state, updateState];
};

export default useLocalStorage;
